import { MainLayoutSimple } from "components/layouts/MainLayoutSimple";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import Activities from "../page";

const routes: AppRouteType[] = [
  {
    path: slugs.activities,
    component: Activities,
    container: MainLayoutSimple,
    isAuthNeeded: true,
  },
];

export default routes;
